<template>
  <form @submit.prevent.stop="submit()">
    <div class="columns is-multiline is-margin-top-small">
      <div class="column is-12 is-padding-bottom-xsmall is-paddingless">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <div class="control">
                <v-input id="name" name="name" @input="val => origin.name = val" :model="origin.name"
                        label="Nom *"
                        v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Nom">
                </v-input>
              </div>
            </div>
          </div>
          <div v-if="isSuperAdmin" class="column is-6">
            <span class="label is-margin-bottom">Bloquer la suppression</span>
            <input id="protected" type="checkbox" name="protected"
                  class="switch is-success is-rounded is-medium" v-model="origin.protected">
            <label for="protected" class="label">
              <span v-if="origin.protected" class="is-size-6 has-text-grey is-padding-top-xxsmall">Oui</span>
              <span v-else class="is-size-6 has-text-grey is-padding-top-xxsmall">Non</span>
            </label>
          </div>
        </div>
        <div v-if="multidiffEnabled" class="columns">
          <div class="column is-narrow">
            <span class="label is-margin-bottom">Multidiffusion</span>
            <input id="multidiffusion" type="checkbox" name="multidiffusion"
                  class="switch is-success is-rounded is-medium" v-model="origin.multidiffusion">
            <label for="multidiffusion" class="label">
              <span v-if="origin.multidiffusion" class="is-size-6 has-text-grey is-padding-top-xxsmall">Oui</span>
              <span v-else class="is-size-6 has-text-grey is-padding-top-xxsmall">Non</span>
            </label>
          </div>
          <div v-if="origin.multidiffusion" class="column is-one-third">
            <v-input id="multidiffusion_code" name="multidiffusion_code" @input="val => origin.multidiffusion_code = val" :model="origin.multidiffusion_code"
                     classes="input" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Code MGC Connecting" label="Code MGC Connecting">
            </v-input>
          </div>
          <div v-if="origin.multidiffusion" class="column is-one-third">
            <v-input id="multidiffusion_name" name="multidiffusion_name" @input="val => origin.multidiffusion_name = val" :model="origin.multidiffusion_name"
                     classes="input" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Nom MGC Connecting" label="Nom MGC Connecting">
            </v-input>
          </div>
        </div>
      </div>
      <div v-if="parent && parent.children.length == 0"
        class="column is-12"
      >
        <div class="notification is-warning">
          En créant une sous-origine, les couts de l'origine parente seront automatiquement calculés à partir des
          sous-origines.
        </div>
      </div>
      <div v-if="!isNew && !hasChildren" class="column is-12">
        <h3 class="is-size-2"><strong>Coûts mensuels</strong></h3>
        <div class="is-tab-like is-border-bottom columns is-gapless">
          <a v-for="y in years" :key="y"
            @click="setCurrentYear(y)"
            :class="{'is-active': y.toString() === currentYear}"
            class="button is-white is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
            {{y}}
          </a>
        </div>
        <div v-for="(mCost, idx) in costs" class="is-border is-margin-top-large has-bg-light" :key="idx">
          <div class="has-text-right">
            <a @click.prevent.stop="removeMonthlyCost(mCost)"
              class="button is-circle is-border is-margin-right is-margin-neg-top">
              <i class="fal fa-trash"></i>
            </a>
          </div>
          <div class="column is-6 is-paddingless-bottom is-paddingless-top">
            <div class="field">
              <label class="label">Mois</label>
              <div class="control">
                <div class="select">
                  <select v-model="mCost.month" required>
                    <option :value="null">Selectionner un Mois</option>
                    <option v-for="month in months" :value="month[0]" :key="month[0]">{{month[1]}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <v-input :id="'cost-' + idx" name="'cost-' + idx" @input="val => mCost.cost = val" :model="mCost.cost"
                      label="Coût"
                      v-validate="'required|decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Coût">
              </v-input>
            </div>
            <div class="column">
              <v-input :id="'margin-' + idx" name="'margin-' + idx" @input="val => mCost.margin = val"
                      :model="mCost.margin"
                      label="Différentiel"
                      v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                      data-vv-as="Marge">
              </v-input>
            </div>
          </div>
        </div>
        <div class="add-origine bloc-add is-border columns is-border-dashed is-margin-top-large"
            @click.prevent.stop="addMonthlyCost">
          <div class="column has-text-grey is-uppercase">Ajouter un coût mensuel</div>
          <div class="column is-narrow">
            <a class="has-text-grey">
              <i class="fal fa-plus-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
      <div class="column is-6">
        <router-link v-if='isNew' :to="{name: 'OriginList'}" class="button has-bg-white is-uppercase is-fullwidth">Annuler</router-link>
        <router-link v-else :to="{name: 'OriginVue', params: {id: origin.pk }}" class="button has-bg-white is-uppercase is-fullwidth">Annuler</router-link>
      </div>
      <div class="column is-6">
        <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
        :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
          <span v-if="!loading">Valider</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import moment from 'moment'
  import { orderBy, findIndex } from 'lodash'
  import {mapGetters} from 'vuex'

  const emptyOrigin = {
    name: null,
    parent: null,
    multidiffusion: false
  }
  const emptyMonthlyCost = {
    month: null,
    year: null,
    cost: null,
    margin: null
  }
  export default {
    name: 'OriginForm',
    props: {
      source: {
        type: Object,
        required: false
      },
      parent: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        originLoading: false,
        origin: {},
        origins: [],
        months: [
          [1, 'Janvier'],
          [2, 'Février'],
          [3, 'Mars'],
          [4, 'Avril'],
          [5, 'Mai'],
          [6, 'Juin'],
          [7, 'Juillet'],
          [8, 'Août'],
          [9, 'Septembre'],
          [10, 'Octobre'],
          [11, 'Novembre'],
          [12, 'Décembre']
        ],
        years: [2017, 2018, 2019, 2020],
        currentYear: null,
        monthly_costs: []
      }
    },
    computed: {
      ...mapGetters(['isSuperAdmin']),
      multidiffEnabled () {
        return JSON.parse(this.$configs.MULTIDIFF_ENABLED)
      },
      isNew () {
        return this.origin.pk === null || this.origin.pk === undefined
      },
      hasChildren () {
        return this.origin.children !== undefined && this.origin.children !== null && this.origin.children.length > 0
      },
      canSubmit () {
        return true
      },
      availableOrigins () {
        return this.origins.filter(x => {
          return x.parent === null
        })
      },
      costs () {
        return this.monthly_costs.filter(x => {
          return x.year === this.currentYear
        })
      }
    },
    methods: {
      addMonthlyCost () {
        let mCost = Object.assign({}, emptyMonthlyCost)
        mCost.year = this.currentYear
        // mCost.month = moment().format('M')
        this.monthly_costs.push(mCost)
      },
      removeMonthlyCost (mCost) {
        let index = findIndex(this.monthly_costs, x => {
          return x === mCost
        })
        if (index >= 0) {
          this.monthly_costs.splice(index, 1)
        }
      },
      loadOrigins () {
        this.originLoading = true
        let query = {
          has_parent: 0,
          sort: 'name:asc'
        }
        this.$api.originService.get(query)
          .then(r => {
            this.origins = r.data
            this.originLoading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
      setCurrentYear (year) {
        this.currentYear = year.toString()
      },
      submit () {
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              let monthlyCosts = this.monthly_costs.slice()
              monthlyCosts = orderBy(monthlyCosts, ['year', 'month'], 'asc')
              this.origin.monthly_costs = monthlyCosts
              this.$emit('submit', this.origin)
            } else {
              this.$emit('failed', this.origin)
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
          .catch(() => {
            this.$emit('failed', this.access)
          })
      }
    },
    created () {
      // this.loadOrigins()
      this.currentYear = moment().format('YYYY')
      if (this.source) {
        this.origin = Object.assign({}, this.source)
        this.monthly_costs = this.origin.monthly_costs.slice()
      } else {
        this.origin = Object.assign({}, emptyOrigin)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/origin/OriginForm.vue